//import { Dispatcher } from "flux";
//export default new Dispatcher();

export default class AppDispatcher {
    static _delegates = {};

    static delegateCount = 0;

    static register = (callback) => {
        AppDispatcher._delegates[AppDispatcher.delegateCount++] = callback;
    }

    static dispatch = (params) => {
        for (const d in AppDispatcher._delegates) {
            if (AppDispatcher._delegates[d]) {
                AppDispatcher._delegates[d].call(this, params);
            }
        }

    }
}